module.exports = __webpack_public_path__ + "assets/img/pci-dss-level-1-service-provider-certification.80cb4815.png";